/**
 * Permission Gate Component
 * Conditionally renders children based on user permissions
 */
import React from 'react';
import { useTenant } from '../../contexts/TenantContext';

/**
 * Permission Gate
 * Shows children only if user has required permission
 * 
 * @param {React.ReactNode} children - Content to render if authorized
 * @param {string|string[]} permission - Required permission(s)
 * @param {React.ReactNode} fallback - Optional content to show if not authorized
 */
export const PermissionGate = ({ children, permission, fallback = null }) => {
  const { hasPermission } = useTenant();

  // Check if user has required permission
  if (permission) {
    const permissions = Array.isArray(permission) ? permission : [permission];
    const hasRequiredPermission = permissions.some(p => hasPermission(p));
    
    if (!hasRequiredPermission) {
      return fallback;
    }
  }

  return <>{children}</>;
};

export default PermissionGate;





